"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradingColony = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var BuildColony_1 = require("../../deferredActions/BuildColony");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var Size_1 = require("../render/Size");
var TradingColony = (function (_super) {
    __extends(TradingColony, _super);
    function TradingColony() {
        return _super.call(this, {
            cost: 18,
            tags: [Tags_1.Tags.SPACE],
            name: CardName_1.CardName.TRADING_COLONY,
            cardType: CardType_1.CardType.ACTIVE,
            metadata: {
                cardNumber: 'C47',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('When you trade, you may first increase that Colony Tile track 1 step.', function (eb) {
                        eb.trade().startEffect.text('+1', Size_1.Size.LARGE);
                    }).br;
                    b.colonies(1);
                }),
                description: 'Place a colony.',
            },
        }) || this;
    }
    TradingColony.prototype.canPlay = function (player) {
        return player.hasAvailableColonyTileToBuildOn();
    };
    TradingColony.prototype.play = function (player) {
        player.game.defer(new BuildColony_1.BuildColony(player, false, 'Select colony for Trading Colony'));
        player.colonyTradeOffset++;
        return undefined;
    };
    TradingColony.prototype.onDiscard = function (player) {
        player.colonyTradeOffset--;
    };
    return TradingColony;
}(Card_1.Card));
exports.TradingColony = TradingColony;
//# sourceMappingURL=TradingColony.js.map